import { Pipe, PipeTransform } from '@angular/core';
import { CoverageTypesUtils } from '@boldpenguin/emperor-services';

@Pipe({
  name: 'formatProduct',
})
export class FormatProductPipe implements PipeTransform {
  // Convert the list of products to a user-friendly string.
  // In this case we want to display the product name in full if there
  // is a single product, or a list of abbreviations + Bundle if there
  // are more than one. If the `abbreviate` boolean is passed in, then the
  // word "Bundle" will be removed and all products will use the
  // shorthand notation (i.e. GL instead of General Liability)
  transform(
    products: { name: string }[],
    abbreviate = false,
    separator = ' + ',
  ): string {
    let productsString = '';

    if (products.length === 1) {
      productsString = this.formatSingleProduct(abbreviate, products);
    } else {
      productsString = this.formatMultiProduct(abbreviate, products, separator);
    }

    return productsString === '' ? 'Other' : productsString;
  }

  private formatSingleProduct(
    abbreviate: boolean,
    products: { name: string }[],
  ): string {
    const firstProductName = products[0].name;
    const formattedStr = abbreviate
      ? CoverageTypesUtils.getCoverageAbbreviation(firstProductName)
      : firstProductName;

    return formattedStr;
  }

  private formatMultiProduct(
    abbreviate: boolean,
    products: { name: string }[],
    separator: string,
  ): string {
    let formattedStr: string;
    formattedStr = `${products
      .map(product => CoverageTypesUtils.getCoverageAbbreviation(product.name))
      .join(separator)}`;

    if (!abbreviate) {
      formattedStr = `${formattedStr} Bundle`;
    }

    return formattedStr;
  }
}
